import withTransactionDetails from 'modules/Wallet/withTransactionDetails';
import { TransactionCoverPage as TransactionCoverPageComponent } from './TransactionCoverPage';

export const TransactionCoverPage = withTransactionDetails(
  TransactionCoverPageComponent,
);
